import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SettingsService } from '../settings/settings.service';
import { UrlService } from '../services/url.service';

@Component({
  selector: 'app-landing-bienvenida',
  standalone: false,
  templateUrl: './landing-bienvenida.component.html',
  styleUrl: './landing-bienvenida.component.less',
})
export class LandingBienvenidaComponent implements OnInit {


  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    public settings: SettingsService,
    private urlService: UrlService,
  ) {



    const urlOriginal = this.router.url
    this.urlService.setOriginalUrl(urlOriginal);


  }

  name: any = "";
  contacto: any = "";
  sinContacto: boolean = false;
  loading_name: boolean = false;



  id_company = localStorage.getItem('company_id');

  ngOnInit() {
    this.getPlatform();

    if (this.id_company != null && this.id_company != '') {
      //this.get_ejecutivo_dinamico();
    }



  }

  currentIndexCarrusel: number = 0;
  boxes = [
    {
      img: '../../assets/bienvenida-img/imagen DESCARGA NUESTRA APP.png',
      title: 'descarga nuestra app',
      description: 'Opera desde cualquier lugar con nuestra app móvil.',
      buttontext: 'explorar app'
    },

    {
      img: '../../assets/bienvenida-img/descarga documentos.png',
      title: 'Descargar tus facturas de simpli',
      description: 'tus operaciones generan facturas por servicio que puedes contabilizar.',
      buttontext: 'Descubre más',
    },

    {
      img: '../../assets/bienvenida-img/imagen SIMULA TU PRIMERA OPERACIÓN.png',
      title: 'Refiere y gana',
      description: 'Con nuestro programa Simpli conecta puedes financiar, referir y ganar.',
      buttontext: 'Conoce más',
      actionUrl: 'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/PDF+-+landing+Welcome+Kit+Digital.pdf'
    },

    {
      img: '../../assets/bienvenida-img/imagen EXPLORA TU DASHBOARD.png',
      title: 'Explora tu dashboard',
      description: 'Conoce todas las funcionalidades disponibles.',
      buttontext: 'Explorar hoy'
    },

    {
      img: '../../assets/bienvenida-img/sigue el avance de tu cesion.png',
      title: 'Sigue el avance de tu cesión',
      description: 'Podrás corroborar cuándo tu factura ha sido pagada.',
      buttontext: 'Comienza aquí'
    },

    {
      img: '../../assets/bienvenida-img/simula nuevas operaciones.png',
      title: 'Simula nuevas operaciones',
      description: 'Anticipa y calcula tus próximas cesiones de facturas.',
      buttontext: 'Simula hoy'
    },
  ];

  get prevIndex() {
    return (this.currentIndexCarrusel - 1 + this.boxes.length) % this.boxes.length;
  }

  get nextIndex() {
    return (this.currentIndexCarrusel + 1) % this.boxes.length;
  }

  prev() {
    this.currentIndexCarrusel = this.prevIndex;
  }

  next() {
    this.currentIndexCarrusel = this.nextIndex;
  }

  realizarAccion(title: string) {
    if (title == 'descarga nuestra app') {
      this.explorarApp();

      return;
    }

    if (title == 'Descargar tus facturas de simpli') {
      this.explorarPlataforma();

      return;
    }

    if (title == 'Refiere y gana') {
      window.open(
        'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/PDF+-+landing+Welcome+Kit+Digital.pdf',
        '_blank'
      );

      return;
    }

    if (title == 'Explora tu dashboard') {
      this.explorarPlataforma();

      return;
    }

    if (title == 'Sigue el avance de tu cesión') {
      this.explorarPlataforma();

      return;
    }

    if (title == 'Simula nuevas operaciones') {
      this.explorarPlataforma();

      return;
    }

  }

  currentIndexCarruselImg: number = 0
  carruselImg = [
    { img: '../../assets/bienvenida-img/0-14.png' },
    { img: '../../assets/bienvenida-img/0-15.png' },
    { img: '../../assets/bienvenida-img/0-16.png' },
    { img: '../../assets/bienvenida-img/0-17.png' },
    { img: '../../assets/bienvenida-img/0-18.png' },
    { img: '../../assets/bienvenida-img/0-19.png' },
  ]

  get visibleImgs() {
    const result = [];
    for (let i = 0; i < 4; i++) {
      result.push(this.carruselImg[(this.currentIndexCarruselImg + i) % this.carruselImg.length]);
    }
    return result;
  }

  prevImg() {
    this.currentIndexCarruselImg = (this.currentIndexCarruselImg - 1 + this.carruselImg.length) % this.carruselImg.length;
  }

  nextImg() {
    this.currentIndexCarruselImg = (this.currentIndexCarruselImg + 1) % this.carruselImg.length;
  }


  currentIndexVideo: number = 0;
  direction: 'left' | 'right' = 'right';

  carruselVideo = [
    {
      video: 'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/landingbienvenida/horizontal+FACTORING.mp4',
      title: '¿qué es el factoring?',
      subtitle: 'El factoring te permite <strong>adelantar el pago de tus facturas</strong>',
      img: '../../assets/bienvenida-img/icono texto FACTORING.png',
      description: '<strong>No es un préstamo,</strong> ni una deuda. Recibes liquidez inmediata y mantienes el control de tu flujo de caja para seguir creciendo sin esperar.',
      button: 'Conoce más aquí'
    },
    // {
    //   video: 'https://simpliassets12daacw.s3.us-east-2.amazonaws.com/landingbienvenida/horizontal+CONFIRMING.mp4',
    //   title: '¿qué es el confirming?',
    //   subtitle: 'El factoring te permite <strong>adelantar el pago de tus facturas</strong>',
    //   img: '../../assets/bienvenida-img/icono texto ORDERING.png',
    //   description: '<strong>No es un préstamo</strong>: No te endeudas. Recibes liquidez inmediata y mantienes el control de tu flujo de caja para seguir creciendo sin esperar.',
    //   button: 'conoce más aquí'
    // }
  ];

  prevVideo() {
    this.direction = 'left';
    this.isVideoPlaying = false;
    this.isLoadingVideo = false;
    this.isVideoLoaded = false;
    this.currentIndexVideo = (this.currentIndexVideo - 1 + this.carruselVideo.length) % this.carruselVideo.length;
  }

  nextVideo() {
    this.direction = 'right';
    this.isVideoPlaying = false;
    this.isLoadingVideo = false;
    this.isVideoLoaded = false;
    this.currentIndexVideo = (this.currentIndexVideo + 1) % this.carruselVideo.length;
  }

  isVideoPlaying: boolean = false;
  isLoadingVideo: boolean = false;
  isVideoLoaded: boolean = false;

  playVideo() {
    this.isVideoPlaying = true;   // muestra el video
    this.isLoadingVideo = true;   // activa el loader
    this.isVideoLoaded = false;   // resetea el estado de cargado
  }

  onVideoLoaded() {
    this.isLoadingVideo = false;  // oculta el loader
    this.isVideoLoaded = true;    // marca el video como cargado
  }

  getSafeVideoUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  explorarPlataforma() {
    this.router.navigate(['login']);
  }

  contactarSoporte() {
    window.open('https://wa.me/+56934677786', '_blank');
  }

  contactarEjecutivo() {
    if (this.contacto == null) {
      this.contactarSoporte();
      return;
    }

    const raw = String(this.contacto).trim();
    if (!raw || /^(null|undefined)$/i.test(raw)) {
      this.contactarSoporte();
      return;
    }

    const tel = raw.replace(/\s+/g, '');
    if (!tel) {
      this.contactarSoporte();
      return;
    }

    window.open(`https://wa.me/+${tel}`, '_blank', 'noopener');
  }

  explorarApp() {
    const plataforma = this.getPlatform();
    if (plataforma === 'Mac' || plataforma === 'iOS') {
      window.open('https://apps.apple.com/cl/app/simpli-factoring/id6740271087', '_blank');
    } else {
      window.open('https://play.google.com/store/apps/details?id=app.simplilatam.com&pcampaignid=web_share', '_blank');
    }
  }

  getPlatform(): string {
    const userAgent = navigator.userAgent.toLowerCase();
    let result: string;
    if (/windows nt/.test(userAgent)) {
      result = 'Windows';
    } else if (/macintosh|mac os x/.test(userAgent)) {
      result = 'Mac';
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      result = 'iOS';
    } else if (/android/.test(userAgent)) {
      result = 'Android';
    } else if (/linux/.test(userAgent)) {
      result = 'Linux';
    } else {
      result = 'Desconocido';
    }

    return result;
  }

  async get_ejecutivo_dinamico() {

    try {
      const bd: any = await this.settings.get_query(1, `/cliente/ejecutivo-representante-empresa/` + this.id_company + '/');
      var body_data: any = bd._body;
      switch (bd.status) {
        case 200:


          if (!body_data.success.info.numero_telefono) {
            this.contacto = null;

          } else {
            this.contacto = body_data.success.info.numero_telefono;
          }



          break;

        default:
          break;
      }

    } catch (bd: any) {


    } finally {

    }
  }



}
